import React from "react";
import "../styles/Spinner.css"; // スピナーのスタイルを定義するCSSファイルをインポート

const Spinner = () => {
  return <div className="spinner-container"></div>;
};

export default Spinner;
